<template>
  <div class="search-component">
    <div class="search-bar-wrapper">
      <input
        type="text"
        v-model="query"
        placeholder="Search..."
        class="search-bar"
      />
      <button @click="filterList" class="search-button">
        <img src="@/assets/search.svg" alt="Search" class="search-icon" />
      </button>
    </div>
    <ul class="results">
      <li v-for="(item, index) in filteredItems" :key="index">
        <router-link :to="{ name: `${item.name}` }" class="title">{{ item.title }}</router-link>
        <p>{{ item.desc }}</p>
      </li>
    </ul>
    <div class="results" v-show="showNoResults">
      No results found
    </div>
  </div>
</template>


<script>
import doc from '@/documents/blogs.js';

export default {
  props: {
    selectedLanguage: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      query: "", // User's search input
      doc: doc.bloglist, // Blog data
      filteredItems: [], // Holds filtered results
      showNoResults: false, // Indicates if "No results" should be displayed
    };
  },
  methods: {
    filterList() {
      if (!this.query.trim()) {
        this.filteredItems = [];
        this.showNoResults = false;
        return;
      }
      const items = this.doc[this.selectedLanguage] || [];
      this.filteredItems = items.filter((item) =>
        item.title.toLowerCase().includes(this.query.toLowerCase())
      );
      this.showNoResults = this.filteredItems.length === 0;
    },
    resetSearch() {
      this.query = "";
      this.filteredItems = [];
      this.showNoResults = false;
    },
  },
  beforeDestroy() {
    // Reset search when the component is destroyed
    this.resetSearch();
  },
};
</script>



<style lang="scss" scoped>
.search-bar-wrapper {
  display: flex;
  align-items: center;
  width: 90%;
  gap: 5px;
}

.search-bar {
  flex-grow: 1;
  padding: 8px 12px;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  height: 50px;
  background: #ffffff;
  color: #333333;
}

.search-bar::placeholder {
  color: #444444;
}

.search-button {
  background-color: #ff7a00;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-left: 8px;
  padding: 8px 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s;
}

.search-button:hover {
  background-color: #e56d00;
}

.search-icon {
  width: 24px;
  height: 24px;
  filter: brightness(0) invert(1);
}

.results {
  list-style-type: none !important;
  padding: 0;
  margin: 10px 0 0 0 !important;
  width: 90%;
  color: #333333;
  .title {
    font-size: 1.3rem;
    margin-bottom: 12px;
    cursor: pointer;
    color: #204f46;
    font-weight: 600;
  }
  .title:hover {
    color: #34d399;
    text-decoration: underline;
    text-decoration-thickness: 1px;
  }
}

.results li {
  padding: 0;
  border-radius: 4px;
  margin-bottom: 5px;
  border-bottom: 1px solid #e5e5e5;
}

@media (max-width: 768px) {
  .results {
    .title {
      font-size: 1.2rem;
      padding-top: 10px;
    }
    p {
      font-size: 1rem !important;
    }
  }
}
</style>
